import { render } from "./FirstPage.vue?vue&type=template&id=47c2848a&scoped=true"
import script from "./FirstPage.vue?vue&type=script&lang=js"
export * from "./FirstPage.vue?vue&type=script&lang=js"

import "./FirstPage.vue?vue&type=style&index=0&id=47c2848a&scoped=true&lang=css"

import exportComponent from "/Users/afolabitope/Documents/apps/redge/web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47c2848a"]])

export default __exports__